import { z } from 'zod';
/**
 * 店家資訊快照 Schema
 * 用於 orders.tenant_info_snapshot，儲存訂單成立時的店家資訊
 * 即使店家資訊後來變更，訂單仍保留當時的資訊（用於發票等）
 */
export const TenantInfoSnapshotSchema = z.object({
    name: z.string().min(1).describe('店名'),
    tax_id: z.string().optional().nullable().describe('統編（統一編號）'),
    phone: z.string().optional().nullable().describe('電話'),
    address: z.object({
        address_line1: z.string().optional().describe('地址第一行（街道地址）'),
        address_line2: z.string().optional().describe('地址第二行（樓層、室號等）'),
        city: z.string().optional().describe('城市'),
        district: z.string().optional().describe('區/鄉鎮'),
        postal_code: z.string().optional().describe('郵遞區號'),
        country: z.string().default('Taiwan').describe('國家（預設：Taiwan）'),
    }).optional().nullable().describe('地址資訊'),
}).passthrough() // 允許額外欄位以支援未來擴展
    .nullable()
    .optional()
    .describe('店家資訊快照（JSONB 格式）');
